import { GlobalIcon } from '@global-engineering-shared/gweb-global-icons';
import { Header as MuiHeader } from '@global-engineering-shared/gweb-material-global';
import { Toolbar, Typography } from '@global-engineering-shared/gweb-material-ui';

import Navigation from 'components/Header/components/Navigation/Navigation';
import SearchBar from 'components/Header/components/SearchBar/SearchBar';

import useStyles from './Header.styles';

const Header = () => {
  const classMap = useStyles();

  const AppbarProps = {
    classes: {
      root: classMap.root,
    },
  };

  return (
    <MuiHeader
      AppbarProps={AppbarProps}
      leftChildren={
        <Toolbar className={classMap.toolbar}>
          <GlobalIcon data-testid="global-icon" className={classMap.logo} />
          <Typography variant="h3" fontWeight="bold" className={classMap.title}>
            Frame Monitoring
          </Typography>
          <span data-testid="divider" className={classMap.divider} />
          <Navigation />
        </Toolbar>
      }
      rightChildren={
        <>
          <SearchBar />
        </>
      }
    />
  );
};

export default Header;
